import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchPage(_, pageId) {
  return http.get(`${MINERVA_API_URL}/pages/${pageId}`)
    .then(res => (res.data))
    .catch((err) => {
      console.error('err while fetching page:', err);
      return Promise.reject(err);
    });
}

export function updatePage({ dispatch }, { pageId, updateInfo }) {
  return http.patch(`${MINERVA_API_URL}/pages/${pageId}`, updateInfo)
    .then(res => (res.data))
    .catch((err) => {
      console.error('err while updating my page:', err);
      return Promise.reject(err);
    });
}

export function uploadPageImage({ dispatch }, { pageId, imageFile }) {
  const formData = new FormData();
  formData.append('file', imageFile);

  return http.post(`${MINERVA_API_URL}/pages/${pageId}/images`, formData)
    .then(res => (res.data))
    .catch((err) => {
      console.error('err while uploading new page image:', err);
      return Promise.reject(err);
    });
}

export function uploadPageAudio(_, { pageId, audioFile }) {
  const formData = new FormData();
  formData.append('file', audioFile);

  return http.post(`${MINERVA_API_URL}/pages/${pageId}/audios`, formData)
    .then(res => (res.data))
    .catch((err) => {
      console.error('err while uploading new page audio:', err);
      return Promise.reject(err);
    });
}

export function fetchAdminInfo(_, userId) {
  return http.get(`${MINERVA_API_URL}/admins/${userId}`)
    .then(res => (res.data));
}

export function setEditedPageInStore({ commit }, page) {
  commit(types.UPDATE_PAGE, page);

  return Promise.resolve(page);
}



// WEBPACK FOOTER //
// ./src/app/edit-page/store/actions.js